import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { api_url } from "../../../../../../constants";
import FormGenerator from "../../../../../../Components/FormGenerator";
import {
  SetOrganisationProfile,
  UpdateOrganisationProfileError,
} from "./OrganisationProfileActions";
import { Typography } from "@material-ui/core";

// const theme = createMuiTheme({
//   overrides: {
//     MuiFormControl: {
//       root: {
//         width: "100%",
//       },
//     },
//   },
// });

export default function Profile(props) {
  const dispatch = useDispatch();

  const {
    account_directors,
    market_cap,
    market_cap_currency,
    company_registration_number,
    key_stakeholders,
    delivery_locations,
    number_of_employees,

    general_documents,
    accounts_documents,
    account_telephone,
    account_contact,
    internal_notes,
    criteria,
    action_to_leverage_work,
    recognised_brand,
    engaged_stackholder,
    multiple_service_line_opportunity,
    master_vendor_opportunity,
    wealth_mindset_id,
    high_growth_sector_id,
    knowledge_worker_id,
    global_id,
    centralised_hr_id,
    key_stakeholders_based_in,
    priority_criteria,
    opportunities,
    main_access_people_names,
    decision_maker_basis_in,
    account_email,
    company_news,
  } = useSelector((state) => state.organisationProfileReducer.data);
  const reducerData = useSelector(
    (state) => state.organisationProfileReducer.data
  );

  const {
    currencies,
    country_lists,
    employees,
    number_of_employees: totalEmployee,
    criterias,
    high_growth_sectors,
    knowledge_workers,
    globals,
    wealth_mindsets,
    number_of_assignments,
    centralised_hrs,
    action_to_leverage_works,
    priority_criterias,
    key_stakeholders_based_in: stakeholdersBasedIn,
    // account_directors
  } = useSelector((state) => state.commonReducer.organisationDropdowns);
  const opportunitiesSelector = useSelector(
    (state) => state.commonReducer.organisationDropdowns.opportunities
  );

  const userRole = useSelector((state) => state.commonReducer.role);

  const errors = useSelector(
    (state) => state.organisationProfileReducer.errors
  );
  const organisation_id = useSelector(
    (state) => state.organisationProfileReducer.organisation_id
  );

  const userDetails = JSON.parse(sessionStorage.getItem("user") || "{}");

  const handleInputChange = (value, index, type) => {
    props.setSomeChangeDetected(true);
    const updatedForm = formInput;
    if (!type) {
      updatedForm[index]["value"] = value;
    } else {
      updatedForm[index][type] = value;
    }
    setFormInput(updatedForm);
    const formData = {};
    formInput.forEach((item, fIndex) => {
      if (fIndex === index) {
        item?.inputName && (formData[item.inputName] = item?.inputValue ?? "");
        item?.selectName &&
          (formData[item.selectName] = item?.selectValue ?? "");
        item?.name && (formData[item.name] = item?.value ?? "");
        dispatch(SetOrganisationProfile(formData));
      }
    });
    dispatch(UpdateOrganisationProfileError(updatedForm[index].name));
  };

  const OnlyAcuityArray = [
    "account_directors",
    "key_stakeholders_based_in",
    "main_access_people_names",
    "delivery_locations",
    "number_of_employees",
    "account_contact",
    "account_email",
    "account_telephone",
  ];

  const formArray = [
    // {
    //   componentType: "input",
    //   type: "text",
    //   label: "Account Director",
    //   helperText:
    //     errors.account_director && "Please enter account director name",
    //   name: "account_director",
    //   placeholder: "Name",
    //   handleChange: handleInputChange,
    //   value: account_director,
    // },
    {
      componentType: "multiSelectChip",
      label: "Account director",
      name: "account_directors",
      itemArr: employees,
      id: "account_directors",
      placeholder: "Select account directors",
      selectOptions: account_directors,
      value: account_directors,
      handleChange: handleInputChange,
    },
    {
      componentType: "inputWithDropdown",
      label: "Market cap (if listed)",
      type: "number",
      inputName: "market_cap",
      selectName: "market_cap_currency",
      inputPlaceholder: "$00,000,000",
      selectPlaceholder: "Currency",
      selectOptions: currencies,
      handleInputChange: handleInputChange,
      handleSelectChange: handleInputChange,
      inputValue: market_cap,
      selectValue: market_cap_currency || 252,
      selectWithAutoComplete: true,
    },
    {
      componentType: "input",
      type: "text",
      multiline: true,
      label: "Company news",
      required: true,
      name: "company_news",
      placeholder: "Company news",
      handleChange: handleInputChange,
      value: company_news,
    },
    {
      componentType: "input",
      type: "text",
      label: "Company registration number",
      name: "company_registration_number",
      required: true,
      placeholder: "Registration number",
      handleChange: handleInputChange,
      value: company_registration_number,
    },
    // {
    // componentType: "select",
    // label: "Criteria",
    // name: "criteria",
    // placeholder: "Criteria",
    // // selectOptions: [{id: 0, name: 'Low', value: 'Low' }, {id: 1, name: 'Medium', value: 'Medium'},{id: 2, name: 'High', value: 'High'},],
    // selectOptions: criterias,
    // handleChange: handleInputChange,
    // value: criteria,
    // },
    // {
    //   componentType: "MultipleSelect",
    //   label: "Service Offered",
    //   name: "services_offered",
    //   placeholder: "Service Offered",
    //   apiVariable: "services_offered",
    //   handleChange: handleInputChange
    // },
    {
      componentType: "select",
      label: "Opportunities",
      name: "opportunities",
      value: opportunities,
      placeholder: "Select priority criteria",
      selectOptions: opportunitiesSelector,
      handleChange: handleInputChange,
    },
    {
      componentType: "select",
      label: "Priority criteria",
      name: "priority_criteria",
      value: priority_criteria,
      placeholder: "Select priority criteria",
      selectOptions: priority_criterias,
      handleChange: handleInputChange,
    },
    {
      componentType: "SelectSpecific",
      label: "Decision maker based",
      name: "decision_maker_basis_in",
      value: decision_maker_basis_in,
      placeholder: "Select decision maker based",
      selectOptions: country_lists,
      handleChange: handleInputChange,
      id: "decision_maker_basis_in",
    },
    {
      componentType: "SelectSpecific",
      label: "High growth sector",
      name: "high_growth_sector_id",
      value: high_growth_sector_id,
      id: high_growth_sector_id,
      placeholder: "Select high growth sector",
      selectOptions: high_growth_sectors,
      handleChange: handleInputChange,
      dropDown: "HighGrowthSector",
      field_name: "high_growth_sector",
    },
    {
      componentType: "SelectSpecific",
      label: "500+ knowledge workers",
      name: "knowledge_worker_id",
      id: "knowledge_worker_id",
      value: knowledge_worker_id,
      placeholder: "Select 500+ knowledge workers",
      selectOptions: knowledge_workers,
      handleChange: handleInputChange,
      dropDown: "KnowledgeWorker",
      field_name: "knowledge_worker",
    },
    {
      componentType: "SelectSpecific",
      label: "Global or International",
      name: "global_id",
      value: global_id,
      id: global_id,
      placeholder: "Select global or international",
      selectOptions: globals,
      handleChange: handleInputChange,
      dropDown: "Global",
      field_name: "value",
    },
    {
      componentType: "SelectSpecific",
      label: "Wealth mindset",
      name: "wealth_mindset_id",
      value: wealth_mindset_id,
      id: wealth_mindset_id,
      placeholder: "Select wealth mindset",
      selectOptions: wealth_mindsets,
      handleChange: handleInputChange,
      dropDown: "WealthMindset",
      field_name: "wealth_mindset",
    },
    {
      componentType: "input",
      type: "text",
      label: "Recognized brand",
      name: "recognised_brand",
      placeholder: "Recognized brand",
      handleChange: handleInputChange,
      value: recognised_brand,
    },
    {
      componentType: "input",
      type: "text",
      label: "Engaged and committed stakeholder",
      name: "engaged_stackholder",
      placeholder: "Engaged stakeholder",
      handleChange: handleInputChange,
      value: engaged_stackholder,
    },
    {
      componentType: "input",
      type: "text",
      label: "Multiple service line opportunity",
      name: "multiple_service_line_opportunity",
      placeholder: "Multiple service line opportunity",
      handleChange: handleInputChange,
      value: multiple_service_line_opportunity,
      multiline: true,
    },
    {
      componentType: "input",
      type: "text",
      label: "Master vendor opportunity",
      name: "master_vendor_opportunity",
      placeholder: "Master vendor opportunity",
      handleChange: handleInputChange,
      value: master_vendor_opportunity,
    },
    {
      componentType: "SelectSpecific",
      label: "Centralised HR",
      name: "centralised_hr_id",
      value: centralised_hr_id,
      id: centralised_hr_id,
      placeholder: "Select centralised HR",
      selectOptions: centralised_hrs,
      handleChange: handleInputChange,
      dropDown: "CentralisedHr",
      field_name: "centralised_hr",
    },
    {
      componentType: "multiSelectChip",
      label: "Key stakeholders based in",
      name: "key_stakeholders_based_in",
      id: "key_stakeholders_based_in",
      placeholder: "Key stakeholders based in",
      value: key_stakeholders_based_in,
      itemArr: stakeholdersBasedIn,
      handleChange: handleInputChange,
    },
    {
      componentType: "multiSelectChip",
      label: "Key stakeholders",
      name: "key_stakeholders",
      id: "key_stakeholders",
      placeholder: "Key stakeholders",
      value: key_stakeholders,
      itemArr: employees,
      handleChange: handleInputChange,
    },
    // {
    //   componentType: "CustomSelectMulti",
    //   label: "Key Stakeholders",
    //   name: "key_stakeholders",
    //   id: "key_stakeholders",
    //   placeholder: "Key stakeholders",
    //   value: [],
    //   itemArr: employees,
    //   selectOptions: key_stakeholders,
    //   reducerData: reducerData,
    //   section: "profile",
    // },
    {
      componentType: "input",
      type: "text",
      multiline: true,
      label: "Names of people who have main access",
      name: "main_access_people_names",
      placeholder: "Names of people who have main access",
      handleChange: handleInputChange,
      value: main_access_people_names,
    },
    {
      componentType: "multiSelectChip",
      label: "Delivery locations",
      name: "delivery_locations",
      placeholder: "Countries",
      id: "delivery_locations",
      value: delivery_locations,
      itemArr: country_lists,
      handleChange: handleInputChange,
    },
    // {
    //   componentType: "CustomSelectMulti",
    //   label: "Delivery Locations",
    //   name: "delivery_locations",
    //   placeholder: "Countries",
    //   id: "delivery_locations",
    //   value: [],
    //   itemArr: country_lists,
    //   selectOptions: delivery_locations,
    //   reducerData: reducerData,
    //   section: "profile",
    // },
    {
      componentType: "SelectSpecific",
      label: "Number of employees",
      id: "number_of_employees",
      name: "number_of_employees",
      placeholder: "Employees",
      // selectOptions: [
      // { id: "Range 0-50", value: "Range 0-50" },
      // { id: "Range 50-100", value: "Range 50-100" },
      // { id: "Range 100-500", value: "Range 100-500" },
      // { id: "Range 500-1000", value: "Range 500-1000" },
      // { id: "Range 1000-5000", value: "Range 1000-5000" },
      // { id: "Range 5000-10000", value: "Range 5000-10000" },
      // { id: "Range 10000+", value: "Range 10000+" },
      //   {id: '0-50', value:'0-50'},
      //   {id: '50-100', value:'50-100'},
      //   {id: '1000-500', value:'100-500'},
      // ],
      selectOptions: totalEmployee,
      handleChange: handleInputChange,
      value: number_of_employees,
    },
    {
      componentType: "uploadFiles",
      name: "general_documents",
      label: "General documentation",
      handleChange: handleInputChange,
      value: general_documents,
      labelStyle: { textTransform: "none" },
    },
    {
      componentType: "uploadFiles",
      name: "accounts_documents",
      label: "Accounts upload",
      handleChange: handleInputChange,
      value: accounts_documents,
      labelStyle: { textTransform: "none" },
    },
    {
      componentType: "input",
      // type: "number",
      label: "Accounts contact name",
      name: "account_contact",
      helperText:
        errors.account_contact && "Please enter Accounts Contact name",
      required: true,
      placeholder: "Accounts contact name",
      handleChange: handleInputChange,
      value: account_contact,
    },
    {
      componentType: "input",
      // type: "number",
      label: "Accounts email",
      name: "account_email",
      helperText: errors.account_email && "Please enter Accounts Email",
      required: true,
      placeholder: "Accounts email",
      handleChange: handleInputChange,
      value: account_email,
    },
    {
      componentType: "phone",
      label: "Account telephone",
      name: "account_telephone",
      handleChange: handleInputChange,
      value: account_telephone,
    },
    {
      componentType: "input",
      type: "text",
      multiline: true,
      label: "Profile internal notes",
      required: true,
      name: "internal_notes",
      placeholder: "Notes",
      handleChange: handleInputChange,
      value: internal_notes,
    },
  ];

  const newArray =
    userRole !== "admin"
      ? formArray.filter((array) => OnlyAcuityArray.includes(array.name))
      : formArray;

  const [formInput, setFormInput] = useState(newArray);

  useEffect(() => {
    setFormInput(newArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    errors,
    number_of_assignments,
    high_growth_sectors?.length,
    knowledge_workers?.length,
    globals?.length,
    wealth_mindsets?.length,
    centralised_hrs?.length,
  ]);

  return (
    <FormGenerator
      children={formInput}
      submitURL={api_url.organisation}
      handleNext={props.handleNext}
      nextIndex={2}
      setId={props.setId}
      moduleName="organization"
    />
  );
}
